import { render, staticRenderFns } from "./Leaves.vue?vue&type=template&id=323a8fd9&"
import script from "./Leaves.vue?vue&type=script&lang=js&"
export * from "./Leaves.vue?vue&type=script&lang=js&"
import style0 from "./Leaves.vue?vue&type=style&index=0&id=323a8fd9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports